import React from 'react'
import useDispatch from 'hooks/use-dispatch'
import addEventListenerDomUtil from 'utils/dom/add-event-listener'
import removeEventListenerDomUtil from 'utils/dom/remove-event-listener'
import handlePopStateProductsPageAction from 'pages/Product/containers/HandlePopState/actions/handle'

export default function ProductPageHandlePopState () {
  const dispatch = useDispatch()

  const handlePopState = (event) => {
    dispatch(handlePopStateProductsPageAction({ event }))
  }

  const handleMount = () => {
    addEventListenerDomUtil('popstate', handlePopState)
  }

  const handleUnMount = () => {
    removeEventListenerDomUtil('popstate', handlePopState)
  }

  React.useEffect(() => {
    handleMount()
    return handleUnMount
  }, [])

  return (
    <></>
  )
}
